import { apiClient } from '../services/api';

interface SpeakOptions {
  lang?: string;
  onEnd?: () => void;
  onError?: () => void;
}

let currentAudio: HTMLAudioElement | null = null;
let currentGeneration = 0;

export const stopSpeech = (): void => {
  currentGeneration++;
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.src = '';
    currentAudio = null;
  }
};

export const speak = (text: string, options?: SpeakOptions): void => {
  currentGeneration++;
  const generation = currentGeneration;

  if (currentAudio) {
    currentAudio.pause();
    currentAudio = null;
  }

  apiClient.tts(text, options?.lang).then((url) => {
    if (generation !== currentGeneration) {
      URL.revokeObjectURL(url);
      return;
    }
    const audio = new Audio(url);
    currentAudio = audio;
    audio.onended = () => {
      URL.revokeObjectURL(url);
      currentAudio = null;
      options?.onEnd?.();
    };
    audio.onerror = () => {
      URL.revokeObjectURL(url);
      currentAudio = null;
      options?.onError?.();
    };
    audio.play();
  }).catch(() => {
    if (generation === currentGeneration) {
      options?.onError?.();
    }
  });
};
